import actions from "./actions";

const states = {
    authToken: null,
    sessionId: null,
    isUserHost: false,
    usersLoggeds: [],
    usuarioId: null,
    username: null,
    userAvatar: null,
    roomId: null,
    isRoomHost: false,
    identity: null,
    participants: [],
    roomSocketId: null,
    isOnlyAudio: false,
    isOnlyCamera: false,
    messages: [],
    directHistory: [],
    conversationActive: null,
    participantSelected: null,
    sendEmailToken: null,
    searchForm: "login",
    showSidebar: false,
    isShowOverlay: true,
    isTimeStamp: false,
    timeStamps: [],
    initialMinutes: 0,
    initialSeconds: 0,
    audioSrc: null,
    volumeIconStream: [],
    dataNotes: [],
    actorsResults: [],
    tasks: [],
    areas: [],
    questions: [],
    sendQuestions: [],
    sendDataNotes: [],
    stateDataNotes: [],
    isRoomListener: false,
    isCheckListener: false,
    isRecaptcha: false,
    successMessage: "",
    errorMessage: "",
    notifyMessage: [],
    isNotifyMessage: false
};

const reducer = (state = states, action) => {
    switch (action.type) {
        case actions.SET_AUTH_TOKEN:
            return {
                ...state,
                authToken: action.authToken,
            };
        case actions.SET_SESSION_ID:
            return {
                ...state,
                sessionId: action.sessionId,
            };
        case actions.SET_USERS_LOGGEDS:
            return {
                ...state,
                usersLoggeds: action.usersLoggeds,
            };
        case actions.SET_IS_USER_HOST:
            return {
                ...state,
                isUserHost: action.isUserHost,
            };
        case actions.SET_USUARIO_ID:
            return {
                ...state,
                usuarioId: action.usuarioId,
            };
        case actions.SET_USER_NAME:
            return {
                ...state,
                username: action.username,
            };
        case actions.SET_USER_AVATAR:
            return {
                ...state,
                userAvatar: action.userAvatar,
            };
        case actions.SET_USER_AVATAR:
            return {
                ...state,
                userAvatar: null,
            };
        case actions.SET_SEND_EMAIL_TOKEN:
            return {
                ...state,
                sendEmailToken: action.sendEmailToken,
            };
        case actions.SET_IS_ROOM_HOST:
            return {
                ...state,
                isRoomHost: action.isRoomHost,
            };
        case actions.SET_ROOM_ID:
            return {
                ...state,
                roomId: action.roomId,
            };
        case actions.SET_IDENTITY:
            return {
                ...state,
                identity: action.identity,
            };
        case actions.SET_PARTICIPANTS:
            return {
                ...state,
                participants: action.participants,
            };
        case actions.SET_ROOM_SOCKET_ID:
            return {
                ...state,
                roomSocketId: action.roomSocketId,
            };
        case actions.SET_IS_ONLY_AUDIO:
            return {
                ...state,
                isOnlyAudio: action.isOnlyAudio,
            };
        case actions.SET_IS_ONLY_CAMERA:
            return {
                ...state,
                isOnlyCamera: action.isOnlyCamera,
            };
        case actions.SET_MESSAGES:
            return {
                ...state,
                messages: action.messages,
            };
        case actions.SET_DIRECT_HISTORY:
            return {
                ...state,
                directHistory: action.directHistory,
            };
        case actions.SET_CONVERSATION_ACTIVE:
            return {
                ...state,
                conversationActive: action.conversationActive,
            };
        case actions.SET_PARTICIPANT_SELECTED:
            return {
                ...state,
                participantSelected: action.participantSelected,
            };
        case actions.SET_SEARCH_FORM:
            return {
                ...state,
                searchForm: action.searchForm,
            };
        case actions.SET_IS_SHOW_SIDEBAR:
            return {
                ...state,
                showSidebar: action.showSidebar,
            };
        case actions.SET_IS_SHOW_OVERLAY:
            return {
                ...state,
                isShowOverlay: action.isShowOverlay,
            };
        case actions.SET_IS_TIME_STAMP:
            return {
                ...state,
                isTimeStamp: action.isTimeStamp,
            };
        case actions.SET_TIME_STAMPS:
            return {
                ...state,
                timeStamps: action.timeStamps,
            };
        case actions.SET_INITIAL_MINUTES:
            return {
                ...state,
                initialMinutes: action.initialMinutes,
            };
        case actions.SET_INITIAL_SECONDS:
            return {
                ...state,
                initialSeconds: action.initialSeconds,
            };
        case actions.SET_AUDIO_SRC:
            return {
                ...state,
                audioSrc: action.audioSrc,
            };
        case actions.SET_VOLUME_ICON_STREAM:
            return {
                ...state,
                volumeIconStream: action.volumeIconStream,
            };
        case actions.SET_SUCCESS_MESSAGE:
            return {
                ...state,
                successMessage: action.successMessage,
            };
        case actions.SET_ERROR_MESSAGE:
            return {
                ...state,
                errorMessage: action.errorMessage,
            };
        case actions.SET_DATA_NOTES: {
            return {
                ...state,
                dataNotes: action.dataNotes,
            };
        }
        case actions.SET_REMOVE_DATA_NOTES:
            return {
                ...state,
                dataNotes: state.dataNotes.filter(n => n.id !== action.id),
            };
        case actions.SET_STATE_DATA_NOTES: {
            return {
                ...state,
                stateDataNotes: action.stateDataNotes,
            };
        }
        case actions.SET_REMOVE_STATE_DATA_NOTES:
            return {
                ...state,
                stateDataNotes: state.stateDataNotes.filter(n => n.id !== action.id),
            };
        case actions.SET_ACTORS_RESULTS:
            return {
                ...state,
                actorsResults: action.actorsResults,
            };
        case actions.SET_TASKS:
            return {
                ...state,
                tasks: action.tasks,
            };
        case actions.SET_AREAS:
            return {
                ...state,
                areas: action.areas,
            };
        case actions.SET_QUESTIONS:
            return {
                ...state,
                questions: action.questions,
            };
        case actions.SET_SEND_QUESTIONS:
            return {
                ...state,
                sendQuestions: action.sendQuestions,
            };
        case actions.SET_SEND_DATA_NOTES:
            return {
                ...state,
                sendDataNotes: action.sendDataNotes,
            };
        case actions.SET_IS_ROOM_LISTENER:
            return {
                ...state,
                isRoomListener: action.isRoomListener,
            };
        case actions.SET_IS_CHECK_LISTENER:
            return {
                ...state,
                isCheckListener: action.isCheckListener,
            };
        case actions.SET_IS_RECAPTCHA:
            return {
                ...state,
                isRecaptcha: action.isRecaptcha,
            };
        case actions.SET_NOTIFY_MESSAGE:
            return {
                ...state,
                notifyMessage: action.notifyMessage,
            };
        case actions.SET_IS_NOTIFY_MESSAGE:
            return {
                ...state,
                isNotifyMessage: action.isNotifyMessage,
            };
        default:
            return state;
    }
};

export default reducer;
